(() => {
  function initialize(root) {
    root.querySelectorAll('[data-cb-metal-video]:not([data-cb-metal-video-ready])').forEach((video) => {
      video.dataset.cbMetalVideoReady = 'true';

      const details = video.closest('details');
      const source = video.querySelector('source[data-src]');
      let nearViewport = false;

      function load() {
        if (!source || !source.dataset.src) return;
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
        video.load();
      }

      function sync() {
        if (nearViewport && !document.hidden && (!details || details.open)) {
          load();
          const playback = video.play();
          if (playback && typeof playback.catch === 'function') playback.catch(() => {});
        } else {
          video.pause();
        }
      }

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          nearViewport = entries.some((entry) => entry.isIntersecting);
          sync();
        }, { rootMargin: '350px 0px', threshold: 0.01 });
        observer.observe(video);
      } else {
        nearViewport = true;
        sync();
      }

      if (details) details.addEventListener('toggle', sync);
      document.addEventListener('visibilitychange', sync);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
